<template>
  <div
    class="modal-wrapper type-alert confirm-modal"
    :class="{ 'is-show': isVisible }"
  >
    <span class="bg-cover" @click="onCancel" />
    <div class="dialog-modal modal type-confirm">
      <div class="modal-wrap">
        <div class="dialog-content modal-cont is-show">
          <p class="dialog-tt modal-cont-ttl">
            {{ title }}
          </p>
          <p class="dialog-txt modal-cont-txt">
            {{ message }}
          </p>
        </div>
        <div class="dialog-button btn-grp type-agree">
          <button
            type="button"
            class="btn btn-full btn-dialog btn-confirm-modal"
            @click="onConfirm"
          >
            {{ confirmText }}
          </button>
          <button
            type="button"
            class="btn btn-full btn-dialog btn-confirm-modal btn-cancel"
            @click="onCancel"
          >
            {{ cancelText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "알림",
    },
    message: {
      type: String,
      default: "",
    },
    confirmText: {
      type: String,
      default: "확인",
    },
    cancelText: {
      type: String,
      default: "취소",
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onConfirm() {
      this.$emit("confirm");
    },
    onCancel() {
      this.$emit("cancel");
    },
  },
};
</script>
